<template>
  <div class="he-layout--content unselect">
    <div class="he-layout--content--header">
      <div class="he-layout--content--header--place" />
      <slot name="actions" :formDesign="formData" />
      <el-button type="text" icon="el-icon-copy-document" @click="$emit('confirm', formData)">生成表单</el-button>
      <el-button v-if="checkHideAction(ItemEnum.ACTIONS.SHOWPREVIEW)" class="he-layout--content--header--btn" type="text" icon="el-icon-copy-document" @click="showForm">查看表单</el-button>
      <el-button v-if="checkHideAction(ItemEnum.ACTIONS.SHOWJSON)" class="he-layout--content--header--btn" type="text" icon="el-icon-view" @click="showJSON">查看JSON</el-button>
    </div>
    <h-form-box class="he-layout--content--form" :form-data="formData">
      <draggable
        v-model="formData.formDataList"
        class="he-layout--content--draggable"
        group="HFormGroup"
        animation="300"
      >
        <template v-if="custom">
          <div v-for="li in formData.formDataList" :key="li.fieldId" @click="clickComponent(li)">
            <slot :data="li" @copy="onCopyItem" @delete="onDeleteItem" />
          </div>
        </template>
        <which-element v-for="li in formData.formDataList" v-else :key="li.fieldId" :data="li" @click.native="clickComponent(li)" @copy="onCopyItem" @delete="onDeleteItem" />
      </draggable>
    </h-form-box>
    <el-dialog
      title="查看表单"
      :visible.sync="showFormVisible"
      append-to-body
      width="600px"
    >
      <h-use-form v-if="showFormVisible" :custom="custom" :form-data="formData">
        <div slot-scope="{data, model, type, prop}">
          <slot :data="data" :model="model" :type="type" :prop="prop" />
        </div>
      </h-use-form>
    </el-dialog>
    <el-dialog
      title="查看JSON"
      :visible.sync="showJSONVisible"
      append-to-body
      width="600px"
    >
      <json-viewer v-if="showJSONVisible" :value="formData" :expand-depth="2" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import HFormBox from '../common/FormBox'
import WhichElement from '../components/which-element.vue'
import JsonViewer from 'vue-json-viewer'
import { HUseForm, ItemEnum } from '../index'

export default {
  name: 'Content',
  components: { draggable, HFormBox, WhichElement, JsonViewer, HUseForm },
   inject: {
    formData: {
      default: () => {}
    },
    contentSelectChange: {
      default: () => () => {}
    }
  },
  props: {
    custom: Boolean,
    hideActions: {
      type: [Array, String],
      default: ''
    }
  },
  data() {
    return {
      ItemEnum,
      showFormVisible: false,
      showJSONVisible: false
    }
  },
  created() {
    if (this.formData?.formDataList?.length) {
      this.clickComponent(this.formData.formDataList[0])
    }
  },
  watch: {
    "formData.formDataId": {
      handler(val, oldval) {
        this.clickComponent(this.formData.formDataList[0])
      }
    },
  },
  methods: {
    onCopyItem(item) {
      // console.log('copy', item)
    },
    onDeleteItem(item) {
      // console.log('delete', item)
    },
    checkHideAction(actionKey) {
      if (typeof this.hideActions === 'string') {
        return this.hideActions !== actionKey
      } else if (Object.prototype.toString.call(this.hideActions) === '[object Array]' && this.hideActions.length) {
        return !this.hideActions.find(item => item === actionKey)
      } else {
        return true
      }
    },
    clickComponent(item) {
      this.formData.formDataList.forEach(f => {
        if (f.name === 'Layout') {
          f.setting.colList.forEach(c => {
            if (c) {
              c.makeStyle && (c.makeStyle.active = false)
            }
          })
        }
        if (f === item) f.makeStyle.active = true
        else f.makeStyle.active = false
      })
      typeof this.contentSelectChange === 'function' && this.contentSelectChange(item)
    },
    showForm() {
      // this.formData.formDataList.forEach(item => {
      //   if (item.name === 'Layout') {
      //     item.setting.colList.forEach(col => {
      //       if (col && col.value) {
      //         this.$set(this.formData.model, col.fieldId, col.value)
      //       }
      //     })
      //   } else if (item.value) {
      //     this.$set(this.formData.model, item.fieldId, item.value)
      //   }
      // })
      this.showFormVisible = true
    },
    showJSON() {
      this.showJSONVisible = true
    }
  }
}
</script>

<style lang="scss">
@import '../../index.scss';
.he-layout--content {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding: 10px 15px;
  padding-top: 0;
  @include display-flex(column, nowrap, flex-start, flex-start);
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;

  &--header {
    width: 100%;
    min-height: 41px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;

    &--place {
      flex-grow: 1;
    }
    &--btn {
      padding: 0 10px;
    }
  }

  &--form {
    width: 100%;
    height: 100%;
    overflow: auto;
    @include display-flex(column, nowrap, flex-start, flex-start);
  }

  &--draggable {
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    height: auto;
    box-sizing: border-box;
    padding-bottom: 100px;
    .el-form-item {
      margin-bottom: 0!important;
      width: 100%;
    }
  }
}
</style>
